import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import OperatorApplicationSelectTemplateDialog
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationSelectTemplateDialog.vue";
import {computed, inject, onMounted, ref} from "vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {SHORTCUT_OPEN_TEMPLATES_DIALOG} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import Delay from "~/ts/library/Delay";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    createEmptyMessageTemplateModel,
    OPEN_ADD_TEMPLATE_DIALOG_EVENT
} from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/MessageTemplateButtonInterface";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import useActivated from "~/ts/vuePlugins/useActivated";


import {defineComponent} from 'vue';

let allowedAddTemplateEvent = true;

const __default__ = defineComponent({
    name: "MessageTemplateButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, showFreeDialogForSite, listenShortcut, onTemplateSelect} = useTextareaComponent();

let templatesDialog = ref<{
    visible: boolean,
    addTemplateModel?: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel
}>();


let isInSelectedSection = inject(isInSelectedSectionInjectionKey);
let isRouteActivated = useActivated();
let isActivated = computed(() => {
    return isRouteActivated.value && isInSelectedSection.value
});


addDisposableEvent(OperatorApplicationEventManager.addEventListener(
    OPEN_ADD_TEMPLATE_DIALOG_EVENT,
    function (message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
        if (isActivated.value) {
            if (allowedAddTemplateEvent) {
                allowedAddTemplateEvent = false;
                let model = createEmptyMessageTemplateModel();
                model.text = message.content.text;
                showTemplatesDialog(model);
                setTimeout(() => allowedAddTemplateEvent = true, 1000);
            }
        }
    }
));

function showTemplatesDialog(model?: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel) {
    if (!showFreeDialogForSite()) {
        templatesDialog.value = {
            visible: true,
            addTemplateModel: model
        };
    }
}

onMounted(() => {
    listenShortcut(SHORTCUT_OPEN_TEMPLATES_DIALOG, async () => {
        try {
            await Delay.make(100, SHORTCUT_OPEN_TEMPLATES_DIALOG, true);
            showTemplatesDialog();
        } catch (e) {

        }
    });
})

function select(template: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel) {
    onTemplateSelect(template);
    templatesDialog.value = null;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(OperatorApplicationDialogTextareaButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showTemplatesDialog())),
      icon: "bolt",
      tooltip: _unref(__)('Выберите быстрый ответ')
    }, null, 8, ["tooltip"]),
    (_unref(templatesDialog)?.visible)
      ? (_openBlock(), _createBlock(OperatorApplicationSelectTemplateDialog, {
          key: 0,
          visible: _unref(templatesDialog).visible,
          "onUpdate:visible": [
            _cache[1] || (_cache[1] = ($event: any) => ((_unref(templatesDialog).visible) = $event)),
            _cache[2] || (_cache[2] = ($event: any) => (_isRef(templatesDialog) //@ts-ignore
 ? templatesDialog.value = null : templatesDialog = null))
          ],
          "add-template-model": _unref(templatesDialog).addTemplateModel,
          client: _unref(client),
          onSelect: select
        }, null, 8, ["visible", "add-template-model", "client"]))
      : _createCommentVNode("", true)
  ]))
}
}

})